// TODO: rewrite code with no-unused-vars && eqeqeq
/* eslint no-unused-vars: 0, eqeqeq: 0 */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


const base = function base() {
    const Application = window.Application;

    // forms: decoration
    const replaceFormButtonWithLink = function replaceFormButtonWithLink() {
        // Hides button, and allows the corresponding link to submit the form.
        // It DOES NOT support replacing multiple buttons inside a single form.
        // Example markup:
        // <form>
        //     ...
        //     <input class="js-form-button" type="submit" name="action_cancel" value="Cancel" />
        //     <a class="js-form-button-link" href="#" style="display:none">Cancel</a>
        //     ...
        // </form>

        const button = $('.js-form-button', this);
        if (button.length !== 1) {
            // Processing forms with 0 buttons is useless;
            // processing ones with >1 buttons is harmful
            // (it implies rather vague logic of matching buttons to links).
            return;
        }

        const link = $('.js-form-button-link', this);
        if (link.length === 0) {
            // Inside a single form, it is acceptable to have
            // >= 1 links acting as a cancel link.
            return;
        }

        link.click(() => {
            button.click();
            return false;
        });
        link.show();
        button.hide();
    };


    // mocks for Portal legacy
    // TODO: refactor into something reusable and move to an appropriate place

    // Drop-down menus in global navigation
    $(() => {
        /**
         * Drop-down menus should have .js-menu class,
         * links to open these menus — .js-menu-link class.
         * Opening and closing a menu toggles .js-open class on it.
         *
         * Click on a closed menu opens it, and closes all other opened menus;
         * click on an opened menu closes it;
         * click on a document body closes all opened menus.
         *
         * A ui.menu.close event triggered on a document body
         * closes all opened menus.
         */

        const openedClass = 'js-open';
        const closeEvent = 'ui.menu.close';

        const $body = $('body');
        const bindToCloseEvent = (callback) => {
            $body.on(closeEvent, callback);
        };
        const triggerCloseEvent = () => {
            $body.trigger(closeEvent);
        };
        const handleCloseEvent = (event) => {
            const target = event ? $(event.target) : null;
            const triggeredFromMenu = target && target.parents('.js-menu').length;

            if (triggeredFromMenu) {
                return;
            }

            triggerCloseEvent(event);
        };

        const userAgent = navigator.userAgent.toLowerCase();
        const isIPad = /ipad/.test(userAgent);
        if (isIPad) {
            $body.on('touchstart', handleCloseEvent);
        } else {
            $body.click(triggerCloseEvent);
        }

        const MenuView = Backbone.View.extend({
            menuSelector: '.js-menu',
            initialize() {
                const closeThis = () => {
                    this.close($(this.menuSelector).filter(`.${openedClass}`));
                };
                bindToCloseEvent(closeThis);
            },
            events: {
                'click .js-menu-link': 'toggle'
            },
            toggle(event) {
                const $target = $(event.currentTarget);
                const $menuElement = $target.closest(this.menuSelector);

                if (this.opened($menuElement)) {
                    this.close($menuElement);
                } else {
                    handleCloseEvent();
                    this.open($menuElement);
                }

                // prevent click propagating to body
                event.preventDefault();
                event.stopPropagation();
            },
            opened($el) {
                return $el.hasClass(openedClass);
            },
            open($el) {
                $el.addClass(openedClass);
            },
            close($el) {
                $el.removeClass(openedClass);
            }
        });

        const MobileMenuView = MenuView.extend({
            menuSelector: '.js-mobile-menu,.js-menu',
            initialize(options) {
                MenuView.prototype.initialize.call(this, options);

                $body.on('click', '.js-submenu-link', _.bind(this.toggleSubmenu, this));

                bindToCloseEvent(_.bind(this.closeAllSubmenus, this));
            },
            getSubmenu($menuLink) {
                return $($menuLink.data('menu-content-selector'));
            },
            open($menuElement) {
                MenuView.prototype.open.call(this, $menuElement);
                this.getSubmenu($menuElement).show();
            },
            close($menuElement) {
                MenuView.prototype.close.call(this, $menuElement);
                this.getSubmenu($menuElement).hide();
            },
            toggleSubmenu(event) {
                const $submenu = $(event.target).parents('li');
                if (this.openedSubmenu($submenu)) {
                    this.closeSubmenu($submenu);
                } else {
                    this.closeAllSubmenus();
                    this.openSubmenu($submenu);
                }

                // prevent click propagating to body
                event.preventDefault();
                event.stopPropagation();
            },
            openedSubmenu(submenu) {
                return submenu.hasClass(openedClass);
            },
            openSubmenu(submenu) {
                submenu.addClass(openedClass);
            },
            closeSubmenu(submenu) {
                submenu.removeClass(openedClass);
            },
            closeAllSubmenus() {
                $(`.js-submenu.${openedClass}`).each(
                    (idx, submenu) => this.closeSubmenu($(submenu))
                );
            }
        });

        $('.js-global-nav').each(() => {
            let view;
            if ($('.js-mobile-menu', this).size()) {
                view = new MobileMenuView({ el: this });
            } else {
                view = new MenuView({ el: this });
            }
        });

        $('.js-auth-logout-link').on(
            'click',
            (event) => Application.trigger('menu-logout', event)
        );
    });

    $(() => $('form').each(() => replaceFormButtonWithLink.apply(this)));

    const setupAutoHeight = _.debounce((context, reset) => {
        let autoHeightBlock;
        if (context) {
            autoHeightBlock = $('.js-autoheight', context);
        } else {
            autoHeightBlock = $('.js-autoheight');
        }

        if (autoHeightBlock.length === 0) {
            return;
        }

        autoHeightBlock.each(() => {
            const $this = $(this);
            const $autoHeightItems = $this.find('.js-autoheight-item:visible');
            const columns = $this.data('columns') || 2;
            const chunks = [];


            /* Slice visible elements into chunks by columns count */
            for (let i = 0; i < $autoHeightItems.length; i += columns) {
                chunks.push($autoHeightItems.slice(i, i + columns));
            }

            _.each(chunks, ($items) => {
                let maxHeight = 0;
                let itemHeight = 0;
                let childrenHeight = 0;
                const $children = $items.children();

                if (reset) {
                    $children.innerHeight('auto');
                }

                $items.each(() => {
                    const $subChildren = $(this).children();
                    if ($subChildren.length === 1) {
                        childrenHeight = $subChildren.innerHeight();
                        if (childrenHeight > maxHeight) {
                            maxHeight = childrenHeight;
                        }
                    } else {
                        itemHeight = $(this).innerHeight();
                        if (itemHeight > maxHeight) {
                            maxHeight = itemHeight;
                        }
                    }
                });

                if (childrenHeight !== 0) {
                    $children.innerHeight(maxHeight);
                } else {
                    $items.innerHeight(maxHeight);
                }
            });
        });
    });
    $(() => setupAutoHeight());

    const resetAutoHeight = (context) => setupAutoHeight(context, true);

    Application.on('ui.autoheight.reset-request', resetAutoHeight);

    const modifierClass = (blockClass, modifier) => `${blockClass}__${modifier}`;

    const getFieldWrapper = (event, wrapperBlock) => {
        const $field = $(event.target);
        const selector = `.${wrapperBlock}`;
        return $field.parents(selector).first();
    };
    const setFieldFocusStyle = function setFieldFocusStyle(event) {
        getFieldWrapper(event, this.wrapperBlock).addClass(this.wrapperFocusClass);
    };
    const resetFieldFocusStyle = function resetFieldFocusStyle(event) {
        const wrapper = getFieldWrapper(event, this.wrapperBlock);
        const prevent = $('.js-input-prevent-reset-focus:hover', wrapper);

        if (prevent.length) {
            return false;
        }

        wrapper.removeClass(this.wrapperFocusClass);
        return true;
    };
    const setFieldHoverStyle = function setFieldHoverStyle(event) {
        getFieldWrapper(event, this.wrapperBlock).addClass(this.wrapperHoverClass);
    };
    const resetFieldHoverStyle = function resetFieldHoverStyle(event) {
        getFieldWrapper(event, this.wrapperBlock).removeClass(this.wrapperHoverClass);
    };
    const initializeElementsEvents = function initializeElementsEvents(fields, wrapperBlock) {
        const wrapperHoverClass = modifierClass(wrapperBlock, 'hover');
        const wrapperFocusClass = modifierClass(wrapperBlock, 'focus');

        const fieldEventHandler = ((context) => (handler) => _.bind(handler, context))({
            wrapperBlock,
            wrapperFocusClass,
            wrapperHoverClass
        });

        _.each(fields, (field) => {
            const $field = $(field);

            $field.focus(fieldEventHandler(setFieldFocusStyle));
            $field.blur(fieldEventHandler(resetFieldFocusStyle));
            $field.mouseenter(fieldEventHandler(setFieldHoverStyle));
            $field.mouseleave(fieldEventHandler(resetFieldHoverStyle));
        });
    };
    // TODO: use js-classes only
    const initializeAllElementsEvents = function initializeAllElementsEvents(context) {
        const inputElementsNotReadonlySelector = $('input:not([readonly=readonly])', context);
        initializeElementsEvents(inputElementsNotReadonlySelector, 'input-light');
        initializeElementsEvents(inputElementsNotReadonlySelector, 'input-game');
        initializeElementsEvents($('textarea', context), 'form-textarea');
    };

    Application.on('ui.elements.setup-events', (options) => {
        if (options.fields && options.wrapperBlock) {
            initializeElementsEvents(options.fields, options.wrapperBlock);
        } else {
            initializeAllElementsEvents(options.context);
        }
    });

    $(() => initializeAllElementsEvents(document));
};

export default base;



// WEBPACK FOOTER //
// ./static-source/js/base.js